import axios from 'axios'

const authConfig = (access) => ({
  headers: { Authorization: `Bearer ${access}` },
})

// GET preview: { dashboard_name, owner_display_name, role, already_member, valid }.
// A 404 is returned for an invalid, expired, revoked, or nonexistent token —
// deliberately identical in every case, so callers must not try to tell them
// apart.
export const getDashboardInvitationPreview = (token, access) => (
  axios.get(`/api/v1/dashboard/invitations/${encodeURIComponent(token)}/`, authConfig(access))
    .then(response => response.data)
)

// POST accept: { dashboard_code_id, role } on success.
// 400 { detail: 'already_owner' } when the caller owns the dashboard already.
// 404 for the same generic invalid/expired/revoked cases as the preview.
// 429 when the accept throttle (10/hour) trips.
export const acceptDashboardInvitation = (token, access) => (
  axios.post(`/api/v1/dashboard/invitations/${encodeURIComponent(token)}/accept/`, {}, authConfig(access))
    .then(response => response.data)
)
